import React from "react";
import Template from "../components/Template";
import BreadCrumbHero from "../components/BreadCrumbHero";
import CTA from "../components/CTA";
import { Link } from "react-router-dom";
import CustomBanner from "../components/CustomBanner";
import Pricing from "../components/Pricing";

function Fitness() {
  return (
    <Template>
      <CustomBanner
        pageTitle="Start Your Fitness Journey"
        pageSubTitle="Build strength, energy, and consistency starting with a 3 days trial at ₹399."
        linkText={"Start 3 days Trial"}
        linkUrl={"/fitness#pricing"}
        bgImage={"assets/images/daily/b1.jpeg"}
      />

      {/* <BreadCrumbHero
        pageTitle="Start Your Fitness Journey"
        pageSubTitle="Build strength, energy, and consistency starting with a 3 days trial at ₹399."
        linkText={"Start 3 days Trial (₹399)"}
        linkUrl={"/fitness"}
      /> */}

      {/* Ihbox Start */}
      <section className="ihbox-section-one">
        <div className="container">
          {/* <div
            className="pbmit-heading-subheading animation-style1"
            style={{ textAlign: "center", marginBottom: "50px" }}
          >
            <h4 className="pbmit-subtitle">
              <span></span>Coach
            </h4>
            <h2 className="pbmit-title">About the Coach</h2>
          </div> */}

          <div className="row">
            <div className="col-12">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        Wellness & Fitness Expertise
                      </h2>
                      <p
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        I bring over 6+ years of hands on experience in the
                        wellness industry, working at the intersection of
                        fitness, nutrition, and sustainable lifestyle change. My
                        work is grounded in practical application and real life
                        consistency, not short term trends or extreme methods.
                      </p>

                      <h2 className="pbmit-element-title">
                        Certified & Experience Driven
                      </h2>
                      <p
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        I am certified in nutrition coaching, resistance band
                        training, and rehab & prehab protocols. Over the years,
                        I have trained 2,000+ clients through both group
                        programs and personalized 1:1 coaching sessions,
                        supporting individuals at different stages of their
                        fitness and wellness journeys.
                      </p>

                      <h2 className="pbmit-element-title">Beyond Workouts</h2>
                      <p
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        My work goes far beyond workouts. I support clients with
                        personalized diet guidance, habit building strategies,
                        and recovery focused training to help them maintain a
                        healthy, balanced lifestyle alongside real work and
                        personal responsibilities.
                      </p>

                      <p
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Many clients who commit to the process experience
                        meaningful changes improved energy, increased
                        confidence, better movement, and a higher overall
                        quality of life that extends well beyond physical
                        results.
                      </p>

                      <h2 className="pbmit-element-title">
                        Sustainable Results Without Burnout
                      </h2>
                      <p
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        My approach is built around long term results. I help
                        people move better, feel stronger, and live healthier by
                        creating systems that are sustainable, realistic, and
                        supportive without burnout or all or nothing pressure.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 text-center mt-5">
              <Link to="/clarity-call" className="pbmit-btn pbmit-btn-white">
                Clarity Call
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Ihbox End */}

      {/* Ihbox Start */}
      <section className="ihbox-section-one">
        <div className="container">
          <div
            className="pbmit-heading-subheading animation-style1"
            style={{ textAlign: "center", marginBottom: "50px" }}
          >
            <h4 className="pbmit-subtitle">
              <span></span>Fitness Program
            </h4>
            <h2 className="pbmit-title">What You Get</h2>
          </div>
          <div className="row">
            <div className="col-md-6 py-4">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        Guided HIIT, Dance & Yoga Classes
                      </h2>
                      <div
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Join expert led HIIT, dance, and yoga sessions that
                        improve strength, flexibility, stamina, and overall
                        fitness while keeping workouts enjoyable, motivating,
                        and suitable for all experience levels.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 py-4">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        Simple Nutrition Tracking
                      </h2>
                      <div
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Track meals, calories, and hydration using simple tools
                        that help you stay consistent, build healthier habits,
                        and support your fitness goals without restrictive or
                        complex diet plans.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 py-4">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">AI Workout Plans</h2>
                      <div
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Receive AI generated workout plans that adapt to your
                        progress, recovery, and goals, ensuring every session
                        remains effective, safe, personalized, and aligned with
                        your fitness journey.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 py-4">
              <div className="pbmit-ihbox pbmit-ihbox-style-7">
                <div className="pbmit-ihbox-box">
                  <div className="pbmit-ihbox-headingicon">
                    <div className="pbmit-ihbox-contents">
                      <h2 className="pbmit-element-title">
                        1:1 & Group Coach Support
                      </h2>
                      <div
                        className="pbmit-heading-desc"
                        style={{ textAlign: "justify" }}
                      >
                        Access one-on-one coaching or group training sessions
                        led by certified coaches who guide, motivate, and hold
                        you accountable while supporting consistent progress and
                        long term results.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="text-center mt-5">
              <Link to="/fitness" className="pbmit-btn pbmit-btn-white">
                View Fitness Plans
              </Link>
            </div> */}
          </div>
        </div>
      </section>
      {/* Ihbox End */}

      <Pricing />

      <hr />

      {/* FAQ */}
      <section className="section-lgx">
        <div className="container">
          <div className="pbmit-heading-subheading text-center animation-style1">
            <h4 className="pbmit-subtitle">
              <span></span>FAQ
            </h4>
            <h2 className="pbmit-title">Fitness FAQ</h2>
          </div>

          <div className="row justify-content-center">
            {/* Left Column */}
            <div className="col-md-8">
              <div className="accordion" id="accordionExample">
                <div className="accordion-item active">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      What is included in the subscription?
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Live classes, guided workouts, nutrition tracking, and
                      system based coaching (based on plan).
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      Can I cancel anytime?
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Yes. There are no long term contracts.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      Is this beginner friendly?
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Absolutely. The system adapts to your fitness and
                      experience level.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingfour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapsefour"
                      aria-expanded="false"
                      aria-controls="collapsefour"
                    >
                      Is equipment needed to do the workouts?
                    </button>
                  </h2>
                  <div
                    id="collapsefour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingfour"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Basic equipment is recommended, but not mandatory to get
                      started.
                      <br />
                      <br />
                      Most workouts are designed to be home friendly and can be
                      done with:
                      <br />
                      <ul>
                        <li>- Yoga mat</li>
                        <li>
                          - Resistance bands or Light Dumbbells (optional)
                        </li>
                      </ul>
                      <br />
                      If you don’t have equipment, bodyweight alternatives are
                      always provided, especially for beginners. You can start
                      immediately and add equipment later as you progress.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ end */}

      <CTA
        subtitle="Fitness"
        title="Start with the 3 days trial. Build consistency. Upgrade when ready."
        link="/fitness#pricing"
        ctaText="Start 3 days Trial"
        accentColor="#05AAE3"
      />
    </Template>
  );
}

export default Fitness;
